import { Design as UnlayerAttachmentDesign } from 'views/AttachmentTemplates/components';
import { default as useUnlayerAttachmentTemplate } from 'views/AttachmentTemplates/useTemplate';

const IFrameUnlayerAttachmentEditor = props => {
    const unlayerAttachmentTemplate = useUnlayerAttachmentTemplate();

    return (
        <UnlayerAttachmentDesign template={unlayerAttachmentTemplate} showNav={true} isIFrame={true} />
    )
}

export default IFrameUnlayerAttachmentEditor;